import { parseTheme } from "@sqymagma/theme";
import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import _defaultTheme from "../themes/theme.json";
import Helmet from "react-helmet";
import Footer from "../components/Footer";
import Navigation from "../components/SiteNavigation/Index";
import Transition from "../components/Transition";
const defaultTheme = parseTheme(_defaultTheme);

const TimelineLayout = ({ children, path, location }) => {
  
  if (typeof window !== "undefined") {
    // eslint-disable-next-line global-require
    require("smooth-scroll")('a[href*="#"]')
  }


  // Make calendar menu open/close state available to all day headers
  const [ calendarOpen, setCalendarOpen ] = useState(false)
  const openCalendarMenu = () => {
    setCalendarOpen(!calendarOpen)
  }

  // Add prop to chronology children, so they're aware of calendar menu state
  const childrenWithProps = React.Children.map(children, (child, i) =>
    React.cloneElement(child, { 
      openCalendarMenu: openCalendarMenu, 
    })
  );

  return (
    <ThemeProvider theme={defaultTheme}>
      <React.Fragment>
        <Helmet>
          <title>COVID-19-ES cronologia del coronavirus en España</title>
          <link rel="canonical" href="https://coronavirus.secuoyas.com" />
          <link rel="icon" href="/../svg/virus-blue-ico.svg" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>

          <meta charSet="utf-8" />
          <meta name="description" content=" 🦠 Información sobre la pandemia del coronavirus abierta y clara, resumida en hechos y gráficos para el análisis. Información Datos y hechos se entrelazan para enriquecerse mutuamente y mejorar la comunicación."/>
          <meta name="keywords" content="coronavirus,covid-19,visualización covid, datos covid, pandemia"/>
          <meta name="author" content="Secuoyas Experience" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="covid·19-es" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="covid·19-es" />
          <meta property="og:url" content="coronavirus.secuoyas.com" />
          <meta property="og:image" content="/../open-graph-image-blue.png"/>
          <meta property="og:description" content="información y datos sobre el impacto del coronavirus en España"/>
          <meta property="og:image:alt" content="covid·19-es logo" />
          <meta name="twitter:card" content="././open-graph-image-blue.png"/>
          <meta name="twitter:site" content="Cronología de la pandemia del coronavirus en España - covid·19-es"/>
          
        </Helmet>
        <Navigation path={path} calendarOpen={calendarOpen} openCalendarMenu={openCalendarMenu}/>

        <Transition location={location}>{childrenWithProps}</Transition>

        <Footer />
      </React.Fragment>
    </ThemeProvider>
  );
};

export default TimelineLayout;
